import copyObject from "./_copyObject.js";
import keysIn from "./keysIn.js";
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}
export default baseAssignIn;
